import { useEffect, useRef } from 'react'
import isEqual from 'lodash-es/isEqual'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { SUBMENU_DEFAULT_VALUE } from '../../../../../constants/route'
import { getDocumentsPermanentFilters } from '../../../../Document'
import { useAsyncTable } from '../../../../Table'
import { getEntityTabFilterStateApi } from '../../../EntityTab.api'
import { getEntityTabDocumentsListApi } from '../../EntityTabDocuments.api'
import { getEntityTabDocumentsParent } from '../../EntityTabDocuments.utils'

export function useEntityTabDocumentsTable({
  containerRef,
  entity,
  isPreview,
  objectId,
  outboundUuid,
  rootDirectoryId,
  scope,
  sub = SUBMENU_DEFAULT_VALUE,
  tableConfigApi,
}) {
  const stableParamsRef = useRef(null)

  const listApi = getEntityTabDocumentsListApi(outboundUuid)

  useEffect(() => {
    stableParamsRef.current = null
  }, [objectId, rootDirectoryId, scope])

  const filterStateApi = getEntityTabFilterStateApi({
    entityPlural: entity.plural,
    objectId,
    sub,
  })

  function mergeEntityTabDocumentsFilters(filterValues) {
    const baseFilters = filterValues || EMPTY_OBJECT

    return {
      sub_menu: sub,
      ...baseFilters,
      parent: getEntityTabDocumentsParent({ filterValues, rootDirectoryId }),
    }
  }

  function getTableParams({ filterValues }) {
    const filters = mergeEntityTabDocumentsFilters(filterValues)

    const nextParams = objectId
      ? {
          filters,
          object_id: String(objectId),
          scope,
        }
      : { filters }

    if (
      stableParamsRef.current &&
      isEqual(stableParamsRef.current, nextParams)
    ) {
      return stableParamsRef.current
    }

    stableParamsRef.current = nextParams

    return nextParams
  }

  return useAsyncTable({
    containerRef,
    entity,
    filterStateApi,
    getPermanentFilters: getDocumentsPermanentFilters,
    getTableParams,
    isLocalPagination: isPreview,
    listApi,
    sub,
    tableConfigApi,
    transformSaveFilters: mergeEntityTabDocumentsFilters,
    withoutSubMenu: true,
  })
}
